import * as store from '@attain-apps/fe/web/main/lib/store'

import * as models from './models'
import type { State } from './state'

/**
 * Core actions for this feature
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    /* eslint-disable sort-keys */
    getOutcomes: store.actions.request({
      input: store.actions.Data.NONE,
      output: store.actions.Data.asIs<readonly models.Outcome[]>(),
      reducers: {
        request: ({ state }) => ({
          ...state,
          outcomes: { loading: true },
        }),
        success: ({ state, data: { response } }) => ({
          ...state,
          outcomes: { data: response },
        }),
        error: ({ state, data: { error } }) => ({
          ...state,
          outcomes: { error },
        }),
      },
    }),
    getAssignments: store.actions.request({
      input: ({
        filters,
      }: {
        filters?: readonly models.UnitOutcomeAssignment.Filter[]
      } = {}) => ({
        filters: filters ?? models.UnitOutcomeAssignment.Filter.DEFAULTS,
      }),
      output:
        store.actions.Data.asIs<readonly models.UnitOutcomeAssignment[]>(),
      reducers: {
        request: ({ state }) => ({
          ...state,
          assignments: { loading: true },
        }),
        success: ({ state, data: { response } }) => ({
          ...state,
          assignments: { data: response },
        }),
        error: ({ state, data: { error } }) => ({
          ...state,
          assignments: { error },
        }),
      },
    }),
    setAssignmentsFilters: store.actions.standalone({
      data: store.actions.Data.asIs<{
        filters: readonly models.UnitOutcomeAssignment.Filter[]
      }>(),
      reducer: ({ state, data: { filters: assignmentsFilters } }) => ({
        ...state,
        assignmentsFilters,
      }),
    }),
    getUnits: store.actions.request({
      input: store.actions.Data.NONE,
      output: store.actions.Data.asIs<readonly models.Unit[]>(),
      reducers: {
        request: ({ state }) => ({
          ...state,
          units: { loading: true },
        }),
        success: ({ state, data: { response } }) => ({
          ...state,
          units: { data: response },
        }),
        error: ({ state, data: { error } }) => ({
          ...state,
          units: { error },
        }),
      },
    }),
    /* eslint-enable sort-keys */
  } as const satisfies store.actions.Config.Constraint<State>
}
